import styled from "styled-components";

export const ContentHolder = styled.div`
  &.content-holder {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0;
    box-sizing: border-box;

    .content-list {
      padding: 0px 20px;
    }

    .table-content {
      overflow: auto;
    }
  }
`;

export const FiltersStyled = styled.div`
  width: 100%;
  .filters-order {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-wrap: wrap;
  .field-holder {
    height: 100%;
  }

  .field-holder .select-field-holder {
    height: 100%;
  }

  input[type="text"] {
    border-radius: 8px !important;
  }

  select {
    border-radius: 8px !important;
    width: 100% !important;
    color: #b1b1b1;
    font-size: 13px;
    padding: 5px 16px;
    height: 100%;
  }

  .select-field-holder .arrow-icon {
    top: 8px;
    font-size: 15px;
    font-weight: 700;
  }

  .date-range,
  .status,
  .partner,
  .per_page {
    height: auto;
    width: 100%;
  }

  .date-range {
    width: 250px;
  }

  .select-search-submit-types {
    width: 220px;
    min-width: 180px;

    .field-holder .input {
      width: 100%;
      border-radius: 8px;
    }

    .react-select__placeholder {
      color: rgba(153, 153, 153, 0.6);
      font-size: 0.9rem;
    }
  }

  .multiple-selection {
    width: 180px;

    .field-holder .input {
      width: 180px;
      border-radius: 8px;

      .react-select__placeholder {
        color: rgba(153, 153, 153, 0.6);
        font-size: 0.9rem;
      }
    }
  }

  .state {
    width: 160px;
    height: 44px;

    &.multiples {
      width: 160px;
      & .field-holder .input {
        width: 100%;
        border-radius: 8px !important;
      }
    }
  }

  button {
    align-self: flex-start;
  }
`;
